import md5 from 'js-md5'

const salt = 'mssj_Z6luO4ITFDHfA9fg'
export default function md5Encrypt(str) {
  return md5(str + salt)
}